// extracted by mini-css-extract-plugin
export default {"group":"page_group__qxEYD","input":"page_input__scbRf","icon":"page_icon__Gn1sm","backIcon":"page_backIcon__Q6cbz"};